import React from 'react'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'
import _ from 'lodash'
import * as styles from './styles'
import { AnimationWrapper, Section } from '..'
import system15Animation from '../../lottie-animations/system-08v1'

const propTypes = {
  data: PropTypes.object.isRequired
}

const WhyAitoBlock = ({ data }) => {
  return (
    <styles.WhyAitoContainer>
      <styles.SectionContainer>
        <styles.WhyAitoRow>
          <styles.WhyAitoCol sm={1} xs={0} />
          <styles.WhyAitoCol sm={5} xs={12}>
            <styles.WhyAitoHeader>
              {data.whyAitoHeader}
            </styles.WhyAitoHeader>
          </styles.WhyAitoCol>
        </styles.WhyAitoRow>

        <styles.WhyAitoRow>
          <styles.WhyAitoCol sm={1} xs={0} />
          <styles.WhyAitoCol sm={5} xs={12}>
            {_.map(data.whyAito, (row, i) => (
              <Section key={i}>
                <styles.WhyAitoSmallHeader>
                  {row.header}
                </styles.WhyAitoSmallHeader>
                <styles.WhyAitoText>
                  {row.text}
                </styles.WhyAitoText>
              </Section>
            ))}
          </styles.WhyAitoCol>

          <styles.WhyAitoCol sm={1} xs={0} />
          <styles.WhyAitoCol sm={5} xs={12}>
            <styles.WhyAitoAnimation>
              <AnimationWrapper
                animation={system15Animation}
                pauseAt={2.3}
                animationSpeed={0.7}
              />
            </styles.WhyAitoAnimation>
          </styles.WhyAitoCol>
        </styles.WhyAitoRow>
      </styles.SectionContainer>
    </styles.WhyAitoContainer>
  )
}

WhyAitoBlock.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetWhyAito {
        allYaml(filter: {file: {eq: "why-aito"}}) {
          edges {
            node {
              whyAitoHeader
              whyAito {
                header
                text
              }
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <WhyAitoBlock data={node} />
      )
    }}
  />
)
